import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuditTrailEmpDetails } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "../shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../digital-identity-api-endpoints";

interface GetAuditTrailAuthoringResponse {
  empdetails: AuditTrailEmpDetails[];
}
interface GetAuditTrailEmpDetailResponse {
  empdetailresponse: string;
}

@Injectable({
  providedIn: "root",
})
export class AuditTrailAuthoringService {
  private readonly digitalIdUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}

  getTerminatedEmpDetailView(
    currentPage: number
  ): Observable<AuditTrailEmpDetails[]> {
    return this.http
      .post<GetAuditTrailAuthoringResponse>(
        `${this.digitalIdUrl}${API_ENDPOINTS.EMPDETAILS.TERMINATIONFETCH}`,
        { currentPage }
      )
      .pipe(
        map((response) => response.empdetails),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getTerminatedEmpDetailViewSearch(currentPage: number, searchText: string, filterByHeader: string): Observable<AuditTrailEmpDetails[]> {
    return this.http
    .post<GetAuditTrailAuthoringResponse>(
      `${this.digitalIdUrl}${API_ENDPOINTS.EMPDETAILS.TERMINATIONFETCHSEARCH}`,
      { currentPage, searchText, filterByHeader }
    )
    .pipe(
      map((response) => response.empdetails),
      catchError((error) => this.errorHandlingService.handleError(error))
    );
  }

  getTransferedEmpDetailView(
    currentPage: number
  ): Observable<AuditTrailEmpDetails[]> {
    return this.http
      .post<GetAuditTrailAuthoringResponse>(
        `${this.digitalIdUrl}${API_ENDPOINTS.EMPDETAILS.TRANSFERFETCH}`,
        {  currentPage }
      )
      .pipe(
        map((response) => response.empdetails),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getTransferedEmpDetailViewSearch(currentPage: number, searchText: string, filterByHeader: string): Observable<AuditTrailEmpDetails[]> {
    return this.http
      .post<GetAuditTrailAuthoringResponse>(
        `${this.digitalIdUrl}${API_ENDPOINTS.EMPDETAILS.TRANSFERFETCHSEARCH}`,
        { currentPage, searchText, filterByHeader }
      )
      .pipe(
        map((response) => response.empdetails),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
   }
}
